import useRouter from "common/hooks/use-router";
import { useCallback } from "react";
import CrudEdit from "common/components/Crud/CrudEdit";
import ProductForm from "./ProductForm";

function Product() {
  const router = useRouter();

  const id = router.query.id as string;

  const back = useCallback(() => {
    router.navigate("/products");
  }, [router]);

  return (
    <CrudEdit
      collectionName="products"
      id={id}
      Form={ProductForm}
      onBack={back}
    />
  );
}

export default Product;
